import { Alert } from '@mantine/core';
import { IconAlertCircle, IconCheck } from '@tabler/icons-react';
import { extractErrors } from 'src/auth/utils/extractErrors';

interface AuthFeedbackProps {
  error?: unknown;
  successMessage?: string | null;
}

export const AuthFeedback = ({ error, successMessage }: AuthFeedbackProps) => {
  if (successMessage) {
    return (
      <Alert color="green" title="Success" icon={<IconCheck size={16} />}>
        {successMessage}
      </Alert>
    );
  }

  if (!error) return null;

  const { messages } = extractErrors(error);

  return (
    <Alert color="red" title="Error" icon={<IconAlertCircle size={16} />}>
      {messages.map((msg: string, i: number) => (
        <div key={`${i}-${msg}`}>{msg}</div>
      ))}
    </Alert>
  );
};
